module.exports = __webpack_public_path__ + "media/images/icons/flags/BB-ac9bce1c1534679c9ebd38537ff7795f.svg";